import { Box, Typography, useMediaQuery } from "@mui/material";

const RouteDetailsTab = ({ tripDetailsData }: { tripDetailsData: any }) => {
  const isMobile = useMediaQuery("(max-width: 640px)");

  const routeData = {
    routeCode: tripDetailsData?.routes?.routeCode || "NA",
    routeName: tripDetailsData?.routes?.routeName || "NA",
    distance: "NA",
    duration: "NA",
    tolls: "NA",
  };

  const sourceData = {
    sourceCode: tripDetailsData?.routes?.sourceAddressCode || "NA",
    sourceAddress: tripDetailsData?.routes?.sourceName || "NA",
    scheduledDeparture: "NA",
    estimatedDeparture: "NA",
  };

  const stops = tripDetailsData?.tripDetails?.stops || [];

  const destinationData = {
    destinationCode: tripDetailsData?.routes?.destinationAddressCode || "NA",
    destinationAddress: tripDetailsData?.routes?.destinationName || "NA",
    scheduledArrival: "NA",
    estimatedArrival: "NA",
  };

  return (
    <Box className="p-8 bg-white shadow-md rounded-lg">
      <Typography className="text-xl font-bold mb-8">Route Details</Typography>
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        <div>
          <div className="mb-6">
            <Typography className="text-sm font-medium text-gray-700">Route Code</Typography>
            <Typography className="text-gray-600">{routeData.routeCode}</Typography>
          </div>
          <div className="mb-6">
            <Typography className="text-sm font-medium text-gray-700">Distance</Typography>
            <Typography className="text-gray-600">{routeData.distance}</Typography>
          </div>
          <div className="mb-6">
            <Typography className="text-sm font-medium text-gray-700">Tolls</Typography>
            <Typography className="text-gray-600">{routeData.tolls}</Typography>
          </div>
        </div>

        <div>
          <div className="mb-6">
            <Typography className="text-sm font-medium text-gray-700">Route Name</Typography>
            <Typography className="text-gray-600">{routeData.routeName}</Typography>
          </div>
          <div className="mb-6">
            <Typography className="text-sm font-medium text-gray-700">Duration</Typography>
            <Typography className="text-gray-600">{routeData.duration}</Typography>
          </div>
        </div>
      </div>

      <Typography className="text-xl font-bold mt-12 mb-8">Source</Typography>
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        <div className="mb-6">
          <Typography className="text-sm font-medium text-gray-700">Source Code</Typography>
          <Typography className="text-gray-600">{sourceData.sourceCode}</Typography>
        </div>
        <div className="mb-6">
          <Typography className="text-sm font-medium text-gray-700">Source Address</Typography>
          <Typography className="text-gray-600">{sourceData.sourceAddress}</Typography>
        </div>
      </div>

      <Typography className="text-xl font-bold mt-12 mb-8">Stops</Typography>
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        {stops.map((stop: any, index: number) => (
          <div key={index} className="mb-6">
            <Typography className="text-sm font-medium text-gray-700">Stop {index + 1} - Address</Typography>
            <Typography className="text-gray-600">{stop.stopAddress}</Typography>
            <Typography className="text-sm font-medium text-gray-700 mt-6">Stop {index + 1} - Estimated Arrival Time</Typography>
            <Typography className="text-gray-600">{stop.estimatedArrival || 'NA'}</Typography>
          </div>
        ))}
      </div>

      <Typography className="text-xl font-bold mt-12 mb-8">Destination</Typography>
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        <div className="mb-6">
          <Typography className="text-sm font-medium text-gray-700">Destination Code</Typography>
          <Typography className="text-gray-600">{destinationData.destinationCode}</Typography>
        </div>
        <div className="mb-6">
          <Typography className="text-sm font-medium text-gray-700">Destination Address</Typography>
          <Typography className="text-gray-600">{destinationData.destinationAddress}</Typography>
        </div>
      </div>
    </Box>
  );
};

export default RouteDetailsTab;
